import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CheckCircle2, Cpu, Loader2, TriangleAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { errMsg, useApi } from "@/lib/api";

export default function BuilderStatus() {
  const api = useApi();
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/sites/builder").then(({ data }) => setSt(data)).catch(() => setSt(false)); }, [api]);
  const install = async () => {
    setBusy(true);
    try { const { data } = await api.post("/sites/builder/install"); setSt((s) => ({ ...s, ...data })); toast[data.ok ? "success" : "error"](data.message); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  if (st === null) return null;
  const ok = st && st.ok;
  return (
    <div className={`flex flex-wrap items-center gap-x-4 gap-y-2 rounded-xl border px-4 py-3 text-sm ${ok ? "border-slate-200 bg-white" : "border-amber-200 bg-amber-50"}`} data-testid="builder-status">
      <span className={`inline-flex items-center gap-2 font-medium ${ok ? "text-slate-800" : "text-amber-900"}`}>
        {ok ? <CheckCircle2 size={16} className="text-emerald-600" /> : <TriangleAlert size={16} className="text-amber-600" />}
        {st ? st.message : "Stato del compilatore non disponibile"}
      </span>
      {st && <span className="inline-flex items-center gap-1.5 text-xs text-slate-500"><Cpu size={13} />Node {st.node || "—"} · {st.instances} {st.instances === 1 ? "processo attivo" : "processi attivi"} · fino a {st.max_parallel_per_instance} compilazioni in parallelo per processo</span>}
      {st?.can_install && (
        <Button size="sm" variant="outline" onClick={install} disabled={busy} data-testid="builder-install-btn">
          {busy && <Loader2 size={13} className="mr-1.5 animate-spin" />}Installa dipendenze
        </Button>
      )}
    </div>
  );
}
